export default __webpack_public_path__ + "static/media/NYA.58a6498f.png";